import Script from 'next/script';

import AdClickTracker from './AdClickTracker';
import HouseAnchor from './HouseAnchor';

const ADSENSE_CLIENT_ID = 'ca-pub-2214184889025947';

/**
 * AdSense library loader (adsbygoogle.js).
 *
 * Loads the shared AdSense script. This is REQUIRED for the manual <AdUnit>
 * slots to fill — they have no loader of their own. It does NOT by itself
 * enable Auto Ads: the overlay / anchor / side-rail formats are controlled in
 * the AdSense dashboard (Auto ads settings), not in this code. To run manual
 * units only, keep this loader and turn Auto Ads OFF in the dashboard.
 */
/**
 * `anchor` adds our own anchor bar (HouseAnchor). Opt-in per call site: pass it
 * only on ads pages with no sales CTA of their own (e.g. not on software-quote
 * funnel pages, which already carry a sticky contact bar).
 */
export default function AdSenseLoader({ anchor = false }: { anchor?: boolean }) {
  return (
    <>
      <Script
        id="adsense-loader"
        async
        strategy="afterInteractive"
        src={`https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${ADSENSE_CLIENT_ID}`}
        crossOrigin="anonymous"
      />
      <AdClickTracker />
      {anchor ? <HouseAnchor /> : null}
    </>
  );
}
